import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LiveChat } from '../interface/liveChat';
import { UserAPI } from '../supersports-services';

const initialState = {
  isLoading: false,
  ChannelId: '',
  SportRadarMatchId: null,
} as LiveChat;

export const getSportRadarChannel = createAsyncThunk(
  'liveChat/getSportRadarChannel',
  async ({ MatchGroupID, token }: { MatchGroupID: string; token: string }) => {
    return await UserAPI.getSportRadarChannel({ MatchGroupID }, token);
  }
);

export const liveChatSlice = createSlice({
  name: 'liveChat',
  initialState,
  reducers: {
    resetLiveChat: (state) => {
      state.isLoading = false;
      state.ChannelId = '';
      state.SportRadarMatchId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSportRadarChannel.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSportRadarChannel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ChannelId = action.payload.ChannelId;
        state.SportRadarMatchId = action.payload.SportRadarMatchId;
      })
      .addCase(getSportRadarChannel.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { resetLiveChat } = liveChatSlice.actions;

export default liveChatSlice.reducer;
